<!--
================================================
Une vue affichée en cas de clic sur le lien "retour"
du formulaire de paiement stripe

ex: http://localhost:8080/fr/disney-inc/subscription/cancel?workspace=disney-workspace&user=Walt%40disney.com
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <app-layout-comp>
    <div slot="AppContent" id="SubscriptionCancelView" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
      <div class="columns">
        <div class="column">

          <div class="blocConfirm box px-6 py-6 has-text-left">

            <div class="is-size-4  mb-4">
              {{ $t('PaiementAnnulé') }}
            </div>

            <p class="confirmMsg2 has-text-grey mb-6"
               v-html="$t('SiVousAvezLaMoindreQuestionNHésitezPasÀNousContacter')">
            </p>

            <router-link id="back2Sub" class="button  is-size-6"
                         v-bind:to="{ name: 'workspace-subscription',params:{locale:locale,organization:organizationSlug, workspace:$auth.getActiveWorkspace()},query:{cycle:'month',pgr:planGroup4Locale}}">
              <font-awesome-icon class="icon is-size-7 has-text-grey-light" :icon="['fas', 'arrow-left']"/>
              <span>{{ $t('retourÀLAbonnement') }}</span>
            </router-link>

          </div>
        </div>
      </div>

    </div>
  </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
// @ is an alias to /src
import AppLayoutComp from '@/components/AppLayoutComp.vue'
// import Component from '@/components/Component.vue'
import VueMetaMixin from "../mixins/VueMetaMixin.js";
import SentryMixin from "../mixins/SentryMixin.js";
import InterceptorMixin from "../mixins/InterceptorMixin.js";
import GlobalErrorNotificationMixin from "../mixins/GlobalErrorNotificationMixin.js";
import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
import {mapState} from "vuex";
import {StripeCheckout} from '@vue-stripe/vue-stripe';
import CurrencyMixin from "@/mixins/CurrencyMixin";
import i18nMixin from "@/mixins/i18nMixin";
import TrackingMixin from "@/mixins/TrackingMixin";

export default {
  name: 'SubscriptionCancelView',
  data: function () {
    return {


      locale: this.$route.params.locale,

      // pour les composants où l'user est identifié ///////////////////////
      organizationSlug: this.$route.params.organization,
      workspaceSlug: this.$route.params.workspace
      // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
      //
      // =================================================================
    }
  },
  computed: {

    // computed props for store :
    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    //----------------------------------------------
  },

  components: {
    AppLayoutComp
  },
  mixins: [VueMetaMixin,  i18nMixin, TrackingMixin],
  //==========================================================
  metaInfo() {
    return this.setMeta(this.$t("metaTitleSubscriptionCancel"), this.$t("metaDescDefault"))
  },
  //==========================================================
  methods: {},

  created: function () {
  },

  mounted: function () {
    if (this.workspaceSlug!= undefined) {

      // Tracking de l' abandon de panier
      this.ga4GlobalEventTrack('Checkout canceled' ,{ user: this.$route.query.user, priceId: this.$route.query.priceId})

      this.$mixpanel.track('Checkout canceled', {"workspace":this.workspaceSlug, user: this.$route.query.user, priceId : this.$route.query.priceId})

    }
  },
}
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
/*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/


#SubscriptionCancelView {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////



  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .box {
      background-color: $bulmaBoxBgDark !important;
      color: $darkTxt;

      h1 {
        color: $darkContrastTxt !important;
      }

      .button {
        color: $darkTxt;
        background-color: transparent;
      }
    }

  }

}
</style>
